import * as React from 'react';

import { useDesignSystemFlags } from '../../../Hooks';
import type { IconProps } from '../../Icon';
import { Icon } from '../../Icon';

function SvgSyncIconV1(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6c3.31 0 6 2.69 6 6h-1.79a.5.5 0 00-.36.85l2.79 2.79c.2.2.51.2.71 0l2.79-2.79c.32-.31.1-.85-.35-.85H20c0-4.42-3.58-8-8-8-1.04 0-2.04.2-2.95.57-.67.27-.85 1.13-.34 1.64.27.27.68.38 1.04.23C10.44 6.15 11.21 6 12 6zm-3.86 5.14L5.35 8.35a.492.492 0 00-.7.01l-2.79 2.79c-.32.31-.1.85.35.85H4c0 4.42 3.58 8 8 8 1.04 0 2.04-.2 2.95-.57.67-.27.85-1.13.34-1.64-.27-.27-.68-.38-1.04-.23-.69.29-1.46.44-2.25.44-3.31 0-6-2.69-6-6h1.79c.45 0 .67-.54.35-.86z"
        fill="currentColor"
      />
    </svg>
  );
}

function SvgSyncIconV2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 2.5a5.48 5.48 0 013.817 1.54l.009.009.5.451H11V6h4V2h-1.5v1.539l-.651-.588A7 7 0 001 8h1.5A5.5 5.5 0 018 2.5zM1 10h4v1.5H3.674l.5.451.01.01A5.5 5.5 0 0013.5 8h1.499a7 7 0 01-11.849 5.048L2.5 12.46V14H1v-4z"
        fill="currentColor"
      />
    </svg>
  );
}

function SyncIcon(props: IconProps) {
  const { USE_NEW_ICONS } = useDesignSystemFlags();
  const component = USE_NEW_ICONS ? SvgSyncIconV2 : SvgSyncIconV1;
  return <Icon {...props} component={component} />;
}

export default SyncIcon;
